export const ThousandSeparator = (value) => {
  if (!value) value = 0;

  if (typeof value === "number") {
    return parseFloat(value.toFixed(3)).toLocaleString(undefined, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });
  } else {
    return value?.toLocaleString();
  }
};

export const DecimalSeparator = (value, decimalPlaces = 2) => {
  if (!value) value = 0;

  if (typeof value === "number") {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
    });
  } else {
    return value?.toLocaleString();
  }
};
